import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { IEopReportSectionDetailDTO } from './IEopReportSectionDetailDTO';

@JsonObject()
export class EopReportSectionDetailSalesPaymentsDTO implements IEopReportSectionDetailDTO {

  @JsonProperty('DA')
  public salesAmount: number;

  @JsonProperty('DB')
  public paymentsAmount: number;

  @JsonProperty('DC')
  public description: string;
}
